import React, { PureComponent } from 'react'
import {
  arrayOf, shape, func, string,
} from 'prop-types'
import filter from 'lodash/filter'
import DocumentTitle from 'react-document-title'

import Signin from '../../components/Signin'
import Signup from '../../components/Signup'
import ForgotPassword from '../../components/ForgotPassword'
import processBuilder from '../../shared/utils/processBuilder'
import Header from '../../components/common/Header'
import Footer from '../../components/common/Footer'

import { signInUpServiceConfig } from '../shared/config'
import injectWidget from '../shared/injectWidget'

import '../../components/PassportPage/passportDefaultPage.scss'

const PROCESS_MAPPING = {
  signIn: Signin,
  signUp: Signup,
  forgotPassword: ForgotPassword,
}

function appendClassToKeycloak(appendClass) {
  const keycloakDom = document.querySelector('div.passport-ui-keycloak')
  keycloakDom.classList.add(appendClass)
}

function removeClassToKeycloak(removeClass) {
  const keycloakDom = document.querySelector('div.passport-ui-keycloak')
  keycloakDom.classList.remove(removeClass)
}

class SignInPageWidgetBuilder extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    signinOptions: arrayOf(shape({})),
    customPanelUrl: string,
  }

  static defaultProps = {
    signinOptions: [],
    customPanelUrl: '',
  }

  constructor(props) {
    super(props)
    this.processes = processBuilder(PROCESS_MAPPING, (Process, processProps = {}) => {
      this.setState({ Process, processProps })
    })
    this.state = {
      Process: Signin,
    }
  }

  render() {
    const {
      signinOptions, i18n,
      customPanelUrl,
      clientConfig: {
        activeWidgetMetaHref,
      },
    } = this.props
    const ssoProvider = filter(signinOptions, { viewGroup: 'SSO' })
    const { Process, processProps } = this.state
    const isShowRightSlotIframe = !!customPanelUrl
    let classActions = {}
    if (isShowRightSlotIframe) {
      classActions = {
        appendClassToKeycloak: appendClassToKeycloak,
        removeClassToKeycloak: removeClassToKeycloak,
      }
    }
    return (
      <div className="passport-ui-keycloak">
        <section id="passport_content">
          <DocumentTitle title={i18n('title.signin')} />
          <div className="passport-ui-page">
            <div className="passport-ui-page_content">
              <Process
                {...this.props}
                {...processProps}
                Header={Header}
                processes={this.processes}
                isPage
                renderModel="PAGE_RENDER"
                {...classActions}
              />
              {
                activeWidgetMetaHref && (
                <div className="signin-page_active-widget">
                  <active-widget data-href={activeWidgetMetaHref} />
                </div>
                )
              }
            </div>
          </div>
          {ssoProvider.length === 0 && (
            <div className="fullpage-footer">
              <Footer />
            </div>
          )}
        </section>
      </div>
    )
  }
}

export default injectWidget({
  widget: SignInPageWidgetBuilder,
  serviceConfig: signInUpServiceConfig,
  ftlMode: true,
  enableActiveWidget: true,
})
